import { Stack } from '@mui/material';
import { useTranslate } from 'react-admin';
import type { AdminGatewayAccountListFilters, Gateway } from '@/api/models';
import { EnumMultiSelect } from '@/features/operations/filters/EnumMultiSelect';
import { TagsField } from '@/features/operations/filters/TagsField';

const GATEWAY_VALUES: Gateway[] = ['redsys', 'stripe', 'adyen', 'payten', 'plexo'];

interface GatewayAccountsFiltersFormProps {
  filters: AdminGatewayAccountListFilters;
  onChange: (patch: Partial<AdminGatewayAccountListFilters>) => void;
}

/** Every query parameter `GET /v1/admin/gateway-accounts` accepts, and no more: `tenantCode`, `gateway`. */
export function GatewayAccountsFiltersForm({ filters, onChange }: GatewayAccountsFiltersFormProps) {
  const translate = useTranslate();

  return (
    <Stack spacing={2.5}>
      <TagsField
        label={translate('pay.gatewayAccounts.filters.tenantCode')}
        helperText={translate('pay.gatewayAccounts.filters.tenantCodeHelp')}
        values={filters.tenantCode ?? []}
        onChange={(values) => onChange({ tenantCode: values.length > 0 ? values : undefined })}
      />
      <EnumMultiSelect
        label={translate('pay.gatewayAccounts.filters.gateway')}
        options={GATEWAY_VALUES.map((value) => ({ value, label: translate(`pay.gatewayAccounts.gateway.${value}`) }))}
        values={filters.gateway ?? []}
        onChange={(values) => onChange({ gateway: values.length > 0 ? (values as Gateway[]) : undefined })}
      />
    </Stack>
  );
}
